module.exports = __webpack_public_path__ + "static/media/coaches.7739d546.png";